import './registration-options-modal.less';
import type {ModalWindowBindings, ModalWindowResolveValues} from '../conversation';
import type {IOnInit} from 'angular';
import type {Component} from 'typings/portaro.fe.types';
import type {RegistrationOptions} from '../../../login/registration-options';

export interface RegistrationOptionsModalModel {
    registrationOptions: RegistrationOptions;
}

class RegistrationOptionsModalComponentController implements ModalWindowBindings<RegistrationOptionsModalModel>, IOnInit {
    public resolve: ModalWindowResolveValues<RegistrationOptionsModalModel>;
    private options: RegistrationOptions;

    public $onInit(): void {
        this.options = this.resolve.model.registrationOptions;
    }

    public close() {
        return this.resolve.modalWindowActions.cancel();
    }
}

/**
 * @ngdoc component
 * @name registrationOptionsModal
 * @module portaro.conversation
 *
 * @description
 * Modal window with registration options
 */
// eslint-disable-next-line
export default class RegistrationOptionsModalComponent implements Component<ModalWindowBindings<RegistrationOptionsModalModel>> {
    public static componentName = 'registrationOptionsModal';

    public templateUrl = require('./registration-options-modal.tpl.ftl');
    public bindings = {
        resolve: '<'
    } as const;
    public controller = RegistrationOptionsModalComponentController;
}
